import { Box, IconButton, Typography, useTheme } from '@mui/material';
import arrowBackIconUrl from './Images/arrow-back.svg';
import {
  getReportNavigationIconStyle,
  reportNavigationClassNames,
  reportNavigationStyles,
} from './ReportNavigationComponent.styles';

interface ReportNavigationComponentProps {
  title: string;
  onBackClick: () => void;
}

export const ReportNavigationComponent = ({
  title,
  onBackClick,
}: ReportNavigationComponentProps) => {
  const theme = useTheme();

  return (
    <Box sx={reportNavigationStyles.container(theme)}>
      <Box sx={reportNavigationStyles.backButton(theme)}>
        <IconButton
          aria-label="go back"
          onClick={onBackClick}
          sx={reportNavigationStyles.iconButton(theme)}
        >
          <Box
            component="span"
            className={reportNavigationClassNames.backIcon}
            sx={reportNavigationStyles.backIcon()}
            style={getReportNavigationIconStyle(arrowBackIconUrl)}
            aria-hidden="true"
          />
        </IconButton>
      </Box>
      <Box sx={reportNavigationStyles.titleContainer(theme)}>
        <Typography variant="h6" sx={reportNavigationStyles.title(theme)}>
          {title}
        </Typography>
      </Box>
      <Box sx={reportNavigationStyles.spacer(theme)} />
    </Box>
  );
};

export default ReportNavigationComponent;
